<template>
  <MainLayout>
    <el-card class="roles-management">
      <!-- <el-button
        type="primary"
        size="small"
        style="margin-bottom: 0.625em"
        @click="createRoleDialog = true"
      >
        New Role
      </el-button> -->

      <h3>Role Management</h3>

      <el-table v-loading="loading" :data="roleTableData" fit>
        <!-- <el-table-column width="80">
          <template slot-scope="scope">
            <IconButton
              v-if="scope.row.id !== 1"
              icon="fas fa-trash"
              @click="deleteRole(scope.row)"
            />
          </template>
        </el-table-column> -->

        <el-table-column prop="name" label="Role Name" />

        <el-table-column label="Is Admin" width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.all" type="success">Admin</el-tag>
          </template>
        </el-table-column>

        <!-- Permisson Columns -->
        <el-table-column
          v-for="permission of permissions"
          :key="permission.id"
          :label="permission.display_name"
        >
          {{ permissions[0] }}
          <template slot-scope="scope">
            <el-checkbox
              :disabled="scope.row.all"
              :value="!!scope.row.permissions.find(p => p.id === permission.id)"
              @input="
                enable => onChangedPermission(scope.row, permission, enable)
              "
            />
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- <el-dialog
      title="Create New Role"
      :visible.sync="createRoleDialog"
      width="30%">
      <el-form
        ref="create-role-form"
        :model="createRoleForm"
        :rules="createRoleRules"
        label-width="7.5em"
      >
        <el-form-item
          label="Role name"
          prop="name"
          :error="createRoleErrors['name']"
        >
          <el-input v-model="createRoleForm.name"/>
        </el-form-item>

        <el-form-item label="Is Admin" prop="isAdmin">
          <el-checkbox v-model="createRoleForm.isAdmin"/>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="createRoleDialog = false">Cancel</el-button>
        <el-button
          :loading="createRoleLoading"
          type="primary"
          @click="createRole"
        >
          Create
        </el-button>
      </span>
    </el-dialog> -->
  </MainLayout>
</template>

<script>
import api from "@/api";

export default {
  metaInfo: {
    title: "Roles",
    meta: [{ name: "Roles", content: "roles management" }]
  },

  data() {
    return {
      loading: false,
      roleTableData: [],
      permissions: [],
      createRoleRules: {
        name: [
          {
            required: true,
            message: "Please input Role name",
            trigger: "blur"
          }
        ]
      },

      createRoleDialog: false,
      createRoleLoading: false,
      createRoleForm: {
        name: "",
        isAdmin: false
      },
      createRoleErrors: {}
    };
  },

  created() {
    this.fetchData();
  },

  methods: {
    fetchData() {
      this.fetchRoles();
      this.fetchPermissions();
    },

    async fetchRoles() {
      try {
        this.loading = true;

        api
          .getRoles()
          .then(res => {
            this.roleTableData = res.data;
          })
          .catch(e => {
            console.log(e);
          });
      } catch (err) {
        this.$notify.error(err.message);
      } finally {
        this.loading = false;
      }
    },

    async fetchPermissions() {
      try {
        this.loading = true;
        api
          .getPermissions()
          .then(res => {
            this.permissions = res.data;
          })
          .catch(e => {
            console.log(e);
          });
      } catch (err) {
        this.$notify.error(err.message);
      } finally {
        this.loading = false;
      }
    },

    async onChangedPermission(role, permission, enable) {
      try {
        this.loading = true;
        if (enable) {
          api
            .changePermission(role.id, permission.id)
            .then(res => {
              if (enable) {
                role.permissions.push(permission);
              } else {
                role.permissions.splice(
                  role.permissions.findIndex(p => p.id === permission.id),
                  1
                );
              }
              this.$notify.success(res.message);
            })
            .catch(e => {
              console.log(e);
            });
        } else {
          api
            .deletePermission(role.id, permission.id)
            .then(res => {
              if (enable) {
                role.permissions.push(permission);
              } else {
                role.permissions.splice(
                  role.permissions.findIndex(p => p.id === permission.id),
                  1
                );
              }
              this.$notify.success(res.message);
            })
            .catch(e => {
              console.log(e);
            });
        }
      } catch (err) {
        this.$notify.error(err.message);
      } finally {
        this.loading = false;
      }
    },

    async createRole() {
      try {
        this.createRoleLoading = true;
        this.createRoleErrors = {};

        const res = await api.request({
          method: "post",
          url: "/roles",
          data: this.createRoleForm
        });

        this.roleTableData.push({
          ...this.createRoleForm,
          id: res.data.data.id,
          permissions: []
        });

        this.createRoleDialog = false;

        this.$notify.success(res.data.message);
      } catch (err) {
        const msg = this.getErrorMessage(err);

        if (msg instanceof Object) {
          this.createRoleErrors = msg;
        } else {
          this.$notify.error(msg);
        }
      } finally {
        this.createRoleLoading = false;
      }
    },

    async deleteRole(role) {
      try {
        await this.$confirm(
          "This will permanently delete the role. Continue?",
          "Warning",
          {
            confirmButtonText: "OK",
            cancelButtonText: "Cancel",
            type: "warning"
          }
        );

        this.loading = true;

        const res = await api.request({
          method: "delete",
          url: `/roles/${role.id}`
        });

        this.roleTableData.splice(
          this.roleTableData.findIndex(r => r.id === role.id),
          1
        );

        this.$notify.success(res.data.message);
      } catch (err) {
        this.$notify.error(err.message);
      } finally {
        this.loading = false;
      }
    },

    getErrorMessage(error) {
      if (error.response) {
        const resData = error.response.data;

        if (resData.status_code === 422) {
          return Object.keys(resData.errors).reduce((errors, prop) => {
            errors[prop] = resData.errors[prop].join(", ");

            return errors;
          }, {});
        }

        return resData.message;
      } else {
        return error.message;
      }
    }
  }
};
</script>

<style lang="css" scoped>
.roles-management {
  height: 90%;
  padding: 0 0.9375em;
  margin: 0.625em 0.9375em;
}
</style>
<style>
.el-table th > .cell {
  word-break: normal;
}
</style>
